Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.facebookButtonText = "Sign up With Facebook";
exports.googleButtonText = "Sign up With Google";
exports.signUpButtonText = "Sign up with email and password";
exports.orText = "or";
exports.signUpBodyText = "Value proposition: why users should sign up.";
exports.signUpTitleText = "Sign up";

// Customizable Area End